import axios from 'axios';

export const markAsRead = (id) => {
  return axios.post(`${import.meta.env.VITE_APP_API_URL}mark-as-read`, {
    id
  });
}